<template>
  <b-card>
    <b-card-title class="mb-2">Propuestas de agencias</b-card-title>
    <b-table
      :items="proposals"
      :fields="fields"
      head-variant="light"
      responsive
      show-empty
    >
      <template #cell(image)="data">
        <b-avatar
          :src="data.item.image"
          size="45"
          variant="light-secondary"
          square
        />
      </template>

      <template #cell(agency)="data">
        <span>{{ data.item.agency_name || '—' }}</span>
      </template>

      <template #cell(actions)="data">
        <div class="d-flex align-items-center">
          <b-button
            :id="`btn-view-${data.item.uuid}`"
            variant="flat-primary"
            size="sm"
            class="btn-icon"
            @click="viewProposal(data.item)"
          >
            <feather-icon icon="EyeIcon" size="16" />
          </b-button>
          <b-popover :target="`btn-view-${data.item.uuid}`" triggers="hover" placement="top">
            Ver propuesta
          </b-popover>

          <b-button
            :id="`btn-edit-${data.item.uuid}`"
            variant="flat-secondary"
            size="sm"
            class="btn-icon ml-50"
            @click="editProposal(data.item)"
          >
            <feather-icon icon="Edit2Icon" size="16" />
          </b-button>
          <b-popover :target="`btn-edit-${data.item.uuid}`" triggers="hover" placement="top">
            Editar
          </b-popover>
        </div>
      </template>

      <template #empty>
        <div class="text-center text-muted py-2">Sin propuestas</div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BCard, BTable, BAvatar, BButton, BPopover, BCardTitle } from 'bootstrap-vue'
import { verifyAsset } from "@/libs/utils/urls";
import proposal_service from "@/services/proposals";
import { getUserData } from '@/libs/utils/user';

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BButton,
    BPopover,
    BCardTitle
  },
  data() {
    return {
      verifyAsset,
      proposals: [],
      fields: [
        { key: 'image', label: 'Imagen' },
        { key: 'title', label: 'Título' },
        { key: 'name', label: 'Nombre' },
        { key: 'email', label: 'Correo' },
        { key: 'network', label: 'Red' },
        { key: 'agency_name', label: 'Agencia' },
        { key: 'actions', label: 'Acciones' },
      ],
    };
  },
  created() {
    proposal_service.getProposals().then((response) => {
      if (response.results) {
        const vanity_name = getUserData().meta_info.vanity_name;
        const proposals_filtered = response.results.filter((item) => item.user && item.user.vanity_name !== vanity_name);

        this.proposals = proposals_filtered.map((item) => ({
          uuid: item.uuid,
          image: item.images && item.images.length > 0 ? verifyAsset(item.images[0].media) : null,
          title: item.title || '—',
          name: item.user ? `${item.user.first_name} ${item.user.last_name}` : '—',
          email: item.user ? item.user.email : '—',
          network: item.user_network ? item.user_network.network : '—',
          agency_name: item.agency ? item.agency.name : null,
          ...item,
        }));
      }
    });
  },
  methods: {
    viewProposal(proposal) {
      const route = this.$router.resolve({ name: 'view_proposals', params: { vanity_name: proposal.user.vanity_name } });
      window.open(route.href, '_blank');
    },
    editProposal(proposal) {
      if (!proposal.agency) {
        const route = this.$router.resolve({ name: 'view_proposals_edit' });
        window.open(route.href, '_blank');
      } else {
        const route = this.$router.resolve({ name: 'edit_proposal', params: { vanity_name: proposal.user.vanity_name } });
        window.open(route.href, '_blank');
      }
    },
  },
};
</script>
